import { Colors } from 'enums';
import styled from 'styled-components';

export const ToggleContainer = styled.div`
  display: flex;
  column-gap: 18px;
  align-items: center;
  justify-content: flex-start;
`;

export const ToggleInput = styled.input`
  position: absolute;
  height: 0;
  width: 0;
  top: 0;
  left: 0;
  visibility: hidden;

  &:checked + label {
    background: ${Colors.yellow1};
    justify-content: flex-end;
  }
`;

export const ToggleLabel = styled.label`
  box-sizing: border-box;
  position: relative;
  justify-content: flex-start;
  display: flex;
  width: 46px;
  height: 26px;
  padding: 2px;
  background: ${Colors.gray3};
  border-radius: 51px;
  cursor: pointer;

  &:active {
    &::after {
      width: 80%;
    }
  }

  &::after {
    content: '';
    position: relative;
    width: 22px;
    height: 22px;
    background: ${Colors.white};
    border-radius: 47px;
    transition: 0.3s;
  }
`;
